// import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
import { confirmLogin } from '@/utils/util'

const env = process.env.NODE_ENV
const mockBaseUrl = process.env.VUE_APP_MOCK_API_BASE_URL

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 30000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.prototype.$cookie.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      if (token) {
        store.dispatch('Logout')
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.prototype.$cookie.get(ACCESS_TOKEN)
  if (token) {
    config.headers[ACCESS_TOKEN] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }

  if (config.data && config.data.mock) {
    if (env === 'mock') {
      config.baseURL = mockBaseUrl
    }
    delete config.data.mock
  }
  for (const key in config.data) {
    if (config.data[key] && typeof config.data[key] === 'string') {
      config.data[key] = config.data[key].replace(/(^\s*)|(\s*$)/g, '')
    }
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  const token = Vue.prototype.$cookie.get(ACCESS_TOKEN)
  const data = response.data
  if (response.status === 200 && response.request && response.request.responseType === 'blob') return data
  if (+response.data.code !== 0 && +response.data.code !== 200) {
    console.log('response', response)
    if (token) {
      let isLogin = false
      switch (data.code) {
        // case 'AUTHEN0001':
        case 'AUTHEN0002':
          break
        case 'AUTHEN0043':
          notification.error({
            message: '错误',
            description: response.data.msg
          })
          break
        case 'AUTHEN0005':
          break
        case 'AUTHEN0006':
          break
        case 'AUTHEN0007':
          break
        case 'AUTHEN0008':
          break
        case 'AUTHEN0010':
          break
        case 'AUTHEN0016':
          // setTimeout(() => {
          //   window.location.reload()
          // }, 20)
          isLogin = true
          Vue.prototype.$hide()
          store.dispatch('ClearToken')
          confirmLogin()
          break
        default:
          break
      }
      if (isLogin) return false
    }
    if (data.code === 'AUTHEN0001' || data.code === 401001) { // 统一登录：401001 登录失效
      Vue.prototype.$hide()
      confirmLogin()
      return false
    }
    if (data.code === 404001) { // 404001 权限变更
      Vue.prototype.$hide()
      notification.error({
        message: '错误',
        description: '当前账号权限已变更，请重新登录'
      })
      confirmLogin(true)
      return false
    }
    return Promise.reject(data)
  }
  return data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
